import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  MODELO_INFORMACOES_COMPLEMENTARES_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MODELO_INFORMACOES_COMPLEMENTARES_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MODELO_INFORMACOES_COMPLEMENTARES_ENDPOINT,
    id,
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [MODELO_INFORMACOES_COMPLEMENTARES_ENDPOINT],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [MODELO_INFORMACOES_COMPLEMENTARES_ENDPOINT],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [MODELO_INFORMACOES_COMPLEMENTARES_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [MODELO_INFORMACOES_COMPLEMENTARES_ENDPOINT],
    id
  );
}
